import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AppSessionStorageService } from '../services/utils/session-storage.service';
import { RouteConstants } from '../constants/route-constants';
import { WebService } from '../services/web/web.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private router: Router, private webService: WebService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    await this.webService.callKeyGenerateApi();
    if (route.url && route.url.length > 0) {
      if (!AppSessionStorageService.isLoggedIn()) {
        this.router.navigate([RouteConstants.SIGNIN]);
        return false;
      }
      if (AppSessionStorageService.auth?.role == 'installer') {
        if (!RouteConstants.INSTALLER_ROUTES.includes(route.url[0].path)) {
          this.webService.router.navigate([RouteConstants.INSTALLER_DASHBOARD]);
          return false;
        }
      }
      if (AppSessionStorageService.auth?.role == 'administrator') {
        if (!RouteConstants.ADMIN_ROUTES.includes(route.url[0].path)) {
          this.webService.router.navigate([RouteConstants.ADMIN_DASHBOARD]);
          return false;
        }
      }
    }
    return true;
  }
}
